export default class PaymentInfo {
  constructor() {
    this.client_secret = "";
    this.customer = {
      full_name: "",
      email: ""
    };
    this.payment_required = false;
    this.redirect_url = "";
    this.stripe = {
      destination: "",
      public_key: "",
      stripe_account: null,
    };
    this.success_token = "";
    this.show_affirm = false;
  }
}
